import React from 'react'

export const POPOVER_ID = 'floating-ui-root'
export const MODAL_POPOVER_ID = 'modal-popover-root'

export const PopoverRoot = ({ id }: { id?: string }) => (
  <div id={id || POPOVER_ID} />
)
